<!-- eslint-disable vue/html-closing-bracket-newline -->
<!-- eslint-disable vue/first-attribute-linebreak -->
<!-- eslint-disable vue/html-indent -->
<!-- eslint-disable vue/html-self-closing -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
    <label v-if="showFieldNames && (field.name || field.title)" :for="field.uuid" dir="auto" class="label text-2xl"
        :class="{ 'mb-2': !field.description }">
        <MarkdownContent v-if="field.title" :string="field.title" />
        <template v-else>{{ field.name }}</template>
        <template v-if="!field.required"> ({{ t("optional") }}) </template>
    </label>
    <div v-else class="py-1" />

    <div v-if="field.description" dir="auto" class="mb-3 px-1">
        <MarkdownContent :string="field.description" />
    </div>
    <AppearsOn :field="field" />
    <canvas ref="canvas" width="600" height="200" class="mt-4 border rounded pb-2 w-full" />
    <div class="items-center flex pt-5">
        <input v-if="!isTextArea" :id="field.uuid" ref="textInput" v-model="text" :maxlength="cellsMaxLegth" dir="auto"
            class="base-input !text-2xl w-full" :class="{ '!pr-11 -mr-10': !field.validation?.pattern }"
            :required="field.required" :pattern="field.validation?.pattern" :placeholder="`${t('type_here_')}${field.required ? '' : ` (${t('optional')})`
                }`" type="text" :name="`values[${field.uuid}]`" @invalid="
                    field.validation?.message
                        ? $event.target.setCustomValidity(field.validation.message)
                        : ''
                    " @input="updateWrittenSignature" @focus="$emit('focus')" />
        <textarea v-if="isTextArea" :id="field.uuid" ref="textInput" v-model="text" dir="auto"
            class="base-textarea !text-2xl w-full" :placeholder="`${t('type_here_')}${field.required ? '' : ` (${t('optional')})`
                }`" :required="field.required" :name="`values[${field.uuid}]`" @input="resizeTextarea"
            @focus="$emit('focus')" />
        <div v-if="!isTextArea && field.type !== 'cells' && !field.validation?.pattern" class="tooltip"
            :data-tip="t('toggle_multiline_text')">
            <a href="#" class="btn btn-ghost btn-circle btn-sm" @click.prevent="toggleTextArea">
                <IconAlignBoxLeftTop />
            </a>
        </div>
    </div>
    <!-- Font Configurations -->
    <div v-if="true" class="mt-2 flex flex-wrap gap-2 items-center">
        <select v-model="selectedFont" class="select select-bordered bg-white select-sm"
            @change="updateFormattedText(text)">
            <option v-for="font in availableFonts" :key="font" :value="font">
                {{ font }}
            </option>
        </select>

        <div class="relative inline-block">
            <input v-model.number="fontSize" type="number" min="1" max="100" step="1"
                class="input input-bordered input-sm bg-white w-20 pr-8" @input="updateFontSize" />
            <select v-model="fontSize" class="absolute inset-y-0 right-0 w-8 opacity-0 cursor-pointer"
                @change="updateFontSize">
                <option v-for="size in sortedFontSizes" :key="size" :value="size">
                    {{ size }} px
                </option>
            </select>
        </div>

        <button class="button-cs-outline-primary-sm rounded-full"
            :class="{ 'btn-active hover:!bg-cs-main-400': isBold }" @click.prevent="toggleBold">
            B
        </button>
        <button class="button-cs-outline-primary-sm rounded-full"
            :class="{ 'btn-active hover:!bg-cs-main-400': isItalic }" @click.prevent="toggleItalic">
            I
        </button>
        <button class="button-cs-outline-primary-sm rounded-full"
            :class="{ 'btn-active hover:!bg-cs-main-400': isUnderline }" @click.prevent="toggleUnderline">
            U
        </button>
        <div class="flex gap-1">
            <button type="button" class="button-cs-outline-primary-sm rounded-full"
                :class="{ 'btn-active hover:!bg-cs-main-400': textAlign === 'left' }"
                @click.prevent="setTextAlign('left')">
                <IconAlignLeft />
            </button>
            <button type="button" class="button-cs-outline-primary-sm rounded-full"
                :class="{ 'btn-active hover:!bg-cs-main-400': textAlign === 'center' }"
                @click.prevent="setTextAlign('center')">
                <IconAlignCenter />
            </button>
            <button type="button" class="button-cs-outline-primary-sm rounded-full"
                :class="{ 'btn-active hover:!bg-cs-main-400': textAlign === 'right' }"
                @click.prevent="setTextAlign('right')">
                <IconAlignRight />
            </button>
            <button type="button" class="button-cs-outline-primary-sm rounded-full"
                :class="{ 'btn-active hover:!bg-cs-main-400': textAlign === 'justify' }"
                @click.prevent="setTextAlign('justify')">
                <IconAlignJustified />
            </button>
        </div>
        <div class="flex gap-1">
            <span class="w-6 h-6 rounded-full cursor-pointer bg-black border border-base-300" data-color="#000000"
                @click="
                    textColor = '#000000';
                updateFormattedText(text);
                " />
            <span class="w-6 h-6 rounded-full cursor-pointer bg-blue-500 border border-base-300" data-color="#3b82f6"
                @click="
                    textColor = '#3b82f6';
                updateFormattedText(text);
                " />
            <span class="w-6 h-6 rounded-full cursor-pointer bg-red-500 border border-base-300" data-color="#ef4444"
                @click="
                    textColor = '#ef4444';
                updateFormattedText(text);
                " />
            <span class="w-6 h-6 rounded-full cursor-pointer bg-white border border-base-300" data-color="#ffffff"
                style="box-shadow: 0 0 0 1px #ccc" @click="
                    textColor = '#ffffff';
                updateFormattedText(text);
                " />
        </div>
    </div>
</template>

<script>
import {
    IconAlignBoxLeftTop,
    IconAlignLeft,
    IconAlignRight,
    IconAlignCenter,
    IconAlignJustified,
} from "@tabler/icons-vue";
import AppearsOn from "./appears_on";
import MarkdownContent from "./markdown_content";

const scale = 3;

export default {
    name: "TextStep",
    components: {
        IconAlignBoxLeftTop,
        IconAlignLeft,
        IconAlignRight,
        IconAlignCenter,
        IconAlignJustified,
        MarkdownContent,
        AppearsOn,
    },
    inject: ["t"],
    props: {
        field: {
            type: Object,
            required: true,
        },
        showFieldNames: {
            type: Boolean,
            required: false,
            default: true,
        },
        modelValue: {
            type: String,
            required: false,
            default: "",
        },
    },
    emits: ["update:model-value", "update-signature-canvas", "focus"],
    data() {
        return {
            isTextArea: false,
            // Font config
            textColor: "#000000",
            drawingColor: "#000000",
            availableFonts: [
                "Arial",
                "Times New Roman",
                "Courier New",
                "Georgia",
                "Lucida Sans",
                "Verdana",
                "Impact",
                "Italianno",
                "Cookie",
                "Parisienne",
            ],
            fontSize:
                parseInt(localStorage.getItem("selectedFontSizeSignature")) || 16,
            selectedFont: localStorage.getItem("selectedFontSignature") || "Arial",
            isBold: false,
            isItalic: false,
            isUnderline: false,
            fontSizes: JSON.parse(localStorage.getItem("fontSizes")) || [
                8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72,
            ],
            textAlign: "left",
        };
    },
    computed: {
        cellsMaxLegth() {
            if (this.field.type === "cells") {
                const area = this.field.areas?.[0];

                if (area) {
                    return parseInt(area.w / area.cell_w) + 1;
                } else {
                    return null;
                }
            } else {
                return null;
            }
        },
        text: {
            get() {
                return typeof this.modelValue === "string"
                    ? this.modelValue
                    : this.modelValue?.text || "";
            },
            set(value) {
                this.updateFormattedText(value);
            },
        },
        sortedFontSizes() {
            return [...new Set(this.fontSizes)].sort((a, b) => a - b);
        },
    },
    watch: {
        fontSizes: {
            handler(newFontSizes) {
                localStorage.setItem("fontSizes", JSON.stringify(newFontSizes));
            },
            deep: true,
        },
    },
    mounted() {
        if (this.modelValue) {
            this.isTextArea = this.modelValue.toString().includes("\n");
            if (this.isTextArea) {
                this.$nextTick(() => {
                    this.resizeTextarea();
                });
            }
            this.updateWrittenSignature();
        }
    },
    methods: {
        // resizeTextarea () {
        //   const textarea = this.$refs.textarea

        //   textarea.style.height = 'auto'
        //   textarea.style.height = textarea.scrollHeight + 'px'
        // },
        resizeTextarea() {
            const textarea = this.$refs.textInput;
            textarea.style.height = "auto";
            textarea.style.height = textarea.scrollHeight + "px";
        },
        toggleTextArea() {
            this.isTextArea = true;

            this.$nextTick(() => {
                this.$refs.textarea.focus();
                this.$refs.textarea.setSelectionRange(
                    this.$refs.textarea.value.length,
                    this.$refs.textarea.value.length
                );

                this.resizeTextarea();
            });
        },
        updateFormattedText(textValue) {
            const formatted = {
                text: textValue,
                font: this.selectedFont,
                size: this.fontSize,
                bold: this.isBold,
                italic: this.isItalic,
                underline: this.isUnderline,
                color: this.textColor,
                align: this.textAlign,
            };

            this.$emit("update:model-value", formatted.text);
            this.updateWrittenSignature();
            this.storeFontMetadata()
        },
        getWrappedLines(context, text, maxWidth) {
            const lines = [];
            const paragraphs = text.split("\n");

            paragraphs.forEach((paragraph) => {
                if (paragraph.length === 0) {
                    lines.push("");
                    return;
                }

                let currentLine = "";
                const words = paragraph.split(" ");

                for (let i = 0; i < words.length; i++) {
                    let word = words[i];
                    let testLine =
                        currentLine.length > 0 ? currentLine + " " + word : word;
                    let metrics = context.measureText(testLine);
                    let testWidth = metrics.width;

                    if (testWidth > maxWidth && currentLine.length > 0) {
                        lines.push(currentLine);
                        currentLine = word;

                        metrics = context.measureText(currentLine);
                        testWidth = metrics.width;

                        if (testWidth > maxWidth) {
                            let tempLine = "";
                            for (let j = 0; j < word.length; j++) {
                                const char = word[j];
                                const testCharLine = tempLine + char;
                                const charMetrics = context.measureText(testCharLine);
                                if (charMetrics.width > maxWidth && tempLine.length > 0) {
                                    lines.push(tempLine);
                                    tempLine = char;
                                } else {
                                    tempLine = testCharLine;
                                }
                            }
                            if (tempLine.length > 0) {
                                lines.push(tempLine);
                            }
                            currentLine = "";
                        }
                    } else if (testWidth > maxWidth && currentLine.length === 0) {
                        let tempLine = "";
                        for (let j = 0; j < word.length; j++) {
                            const char = word[j];
                            const testCharLine = tempLine + char;
                            const charMetrics = context.measureText(testCharLine);
                            if (charMetrics.width > maxWidth && tempLine.length > 0) {
                                lines.push(tempLine);
                                tempLine = char;
                            } else {
                                tempLine = testCharLine;
                            }
                        }
                        if (tempLine.length > 0) {
                            lines.push(tempLine);
                        }
                        currentLine = "";
                    } else {
                        currentLine = testLine;
                    }
                }
                if (currentLine.length > 0) {
                    lines.push(currentLine);
                }
            });
            return lines;
        },
        updateWrittenSignature() {
            const text = typeof this.text === "object" ? this.text.text : this.text;
            this.isSignatureStarted = !!text;
            const canvas = this.$refs.canvas;
            const context = canvas.getContext("2d");

            context.clearRect(0, 0, canvas.width, canvas.height);
            // Remove white background fill to make it transparent
            // context.fillStyle = "#ffffff";
            // context.fillRect(0, 0, canvas.width, canvas.height);

            const fontFamily = this.selectedFont;
            const fontSize = this.fontSize;
            const fontStyle = this.isItalic ? "italic" : "normal";
            const fontWeight = this.isBold ? "bold" : "normal";

            context.font = `${fontStyle} ${fontWeight} ${fontSize}px ${fontFamily}`;

            context.textBaseline = "top";
            context.fillStyle = this.textColor;

            const padding = 20;
            const maxWidth = canvas.width - padding * 2;

            const wrappedLines = this.getWrappedLines(context, text, maxWidth);

            const lineHeight = fontSize * 1.2;
            const totalTextHeight = wrappedLines.length * lineHeight;

            let currentY = (canvas.height - totalTextHeight) / 2;

            wrappedLines.forEach((line) => {
                let x;
                let lineToDraw = line;
                let textWidth = context.measureText(lineToDraw).width;

                switch (this.textAlign) {
                    case "left":
                        x = padding;
                        context.textAlign = "left";
                        break;
                    case "right":
                        x = canvas.width - padding;
                        context.textAlign = "right";
                        break;
                    case "center":
                        x = canvas.width / 2;
                        context.textAlign = "center";
                        break;
                    case "justify":
                        if (
                            line !== wrappedLines[wrappedLines.length - 1] &&
                            line.includes(" ")
                        ) {
                            const wordsInLine = line.split(" ");
                            const numWords = wordsInLine.length;
                            if (numWords > 1) {
                                const totalWordWidth = wordsInLine.reduce(
                                    (sum, word) => sum + context.measureText(word).width,
                                    0
                                );
                                const totalSpaceWidth = maxWidth - totalWordWidth;
                                const spaceBetweenWords = totalSpaceWidth / (numWords - 1);

                                let currentX = padding;
                                for (let i = 0; i < numWords; i++) {
                                    context.fillText(wordsInLine[i], currentX, currentY);
                                    currentX +=
                                        context.measureText(wordsInLine[i]).width +
                                        spaceBetweenWords;
                                }
                                lineToDraw = null;
                            } else {
                                x = padding;
                                context.textAlign = "left";
                            }
                        } else {
                            x = padding;
                            context.textAlign = "left";
                        }
                        break;
                    default:
                        x = padding;
                        context.textAlign = "left";
                        break;
                }

                if (lineToDraw !== null) {
                    // Gambar baris jika belum digambar oleh justify
                    context.fillText(lineToDraw, x, currentY);
                }

                if (this.isUnderline) {
                    if (lineToDraw === null && this.textAlign === "justify") {
                        textWidth = context.measureText(line).width;
                    }

                    const underlineY = currentY + fontSize + 2;
                    let underlineXStart;
                    let underlineXEnd;

                    switch (this.textAlign) {
                        case "left":
                            underlineXStart = x;
                            underlineXEnd = x + textWidth;
                            break;
                        case "right":
                            underlineXStart = x - textWidth;
                            underlineXEnd = x;
                            break;
                        case "center":
                            underlineXStart = x - textWidth / 2;
                            underlineXEnd = x + textWidth / 2;
                            break;
                        case "justify":
                            underlineXStart = padding;
                            underlineXEnd = padding + textWidth;
                            if (lineToDraw === null && line.includes(" ")) {
                                const wordsInLine = line.split(" ");
                                let currentUnderlineX = padding;
                                const totalWordWidth = wordsInLine.reduce(
                                    (sum, word) => sum + context.measureText(word).width,
                                    0
                                );
                                const totalSpaceWidth = maxWidth - totalWordWidth;
                                const spaceBetweenWords =
                                    totalSpaceWidth / (wordsInLine.length - 1);

                                wordsInLine.forEach((word) => {
                                    const wordWidth = context.measureText(word).width;
                                    context.beginPath();
                                    context.moveTo(currentUnderlineX, underlineY);
                                    context.lineTo(currentUnderlineX + wordWidth, underlineY);
                                    context.strokeStyle = this.textColor;
                                    context.stroke();
                                    currentUnderlineX += wordWidth + spaceBetweenWords;
                                });
                                underlineXStart = null;
                            }
                            break;
                        default:
                            underlineXStart = x;
                            underlineXEnd = x + textWidth;
                            break;
                    }

                    if (underlineXStart !== null) {
                        context.beginPath();
                        context.moveTo(underlineXStart, underlineY);
                        context.lineTo(underlineXEnd, underlineY);
                        context.strokeStyle = this.textColor;
                        context.stroke();
                    }
                }
                currentY += lineHeight;
            });
            localStorage.setItem("selectedFontSizeSignature", this.fontSize);
            localStorage.setItem("selectedFontSignature", this.selectedFont);
            const dataUrl = canvas.toDataURL();

            // Store font metadata in parent component
            this.storeFontMetadata()

            this.$emit("update-signature-canvas", {
                uuid: this.field.uuid,
                dataUrl,
            });
        },
        toggleBold() {
            this.isBold = !this.isBold;
            this.updateFormattedText(this.text);
            this.storeFontMetadata()
        },
        toggleItalic() {
            this.isItalic = !this.isItalic;
            this.updateFormattedText(this.text);
            this.storeFontMetadata()
        },
        toggleUnderline() {
            this.isUnderline = !this.isUnderline;
            this.updateFormattedText(this.text);
            this.storeFontMetadata()
        },
        storeFontMetadata() {
            // Store font metadata in parent component for submission
            if (this.$parent && this.$parent.fontMetadataStore) {
                this.$parent.fontMetadataStore[this.field.uuid] = {
                    type: 'text_signature', // Mark as text signature for PDF processing
                    fontFamily: this.selectedFont,
                    fontSize: this.fontSize,
                    fontSizeUnit: 'px', // Indicate that fontSize is in pixels from canvas
                    canvasWidth: this.$refs.canvas ? this.$refs.canvas.width : 600,
                    canvasHeight: this.$refs.canvas ? this.$refs.canvas.height : 200,
                    isBold: this.isBold,
                    isItalic: this.isItalic,
                    isUnderline: this.isUnderline,
                    textColor: this.textColor,
                    text: typeof this.text === 'object' ? this.text.text : this.text
                }
            }

            // IMPORTANT: Also update field preferences with font size for consistent display
            if (!this.field.preferences) {
                this.field.preferences = {}
            }
            this.field.preferences.font_size = this.fontSize
        },
        updateFontSize() {
            const newSize = parseInt(this.fontSize);
            if (!isNaN(newSize) && !this.fontSizes.includes(newSize)) {
                this.fontSizes.push(newSize);
                this.fontSizes.sort((a, b) => a - b);
            }
            this.updateFormattedText(this.text);
        },
        setTextAlign(align) {
            this.textAlign = align;
            localStorage.setItem("selectedTextAlignSignature", this.textAlign);
            this.updateFormattedText(this.text);
            this.storeFontMetadata()
        },
    },
};
</script>
